import { Component, Input, type OnChanges, type SimpleChanges, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-side-panel',
  imports: [MatButtonModule],
  templateUrl: './side-panel.component.html',
  styleUrl: './side-panel.component.scss',
})
export class SidePanelComponent implements OnInit, OnChanges {
  @Input() panelData: any;
  showPanel = false;

  constructor(
    private readonly router: Router,
    private readonly utils: UtilService,
  ) {}

  ngOnInit(): void {
    this.utils.consoleGroup('panelData: ', this.panelData);
    if (this.panelData?.header) {
      this.showPanel = true;
    } else {
      this.showPanel = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.utils.consoleGroup('side panel changes', changes);
    this.panelData = changes['panelData'].currentValue;
  }
}
